/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocationModel } from '../../models/employee-location-model';

export interface GetEmployeeLocation$Json$Params {
}

export function getEmployeeLocation$Json(http: HttpClient, rootUrl: string, params?: GetEmployeeLocation$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeLocationModel>> {
  const rb = new RequestBuilder(rootUrl, getEmployeeLocation$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeLocationModel>;
    })
  );
}

getEmployeeLocation$Json.PATH = '/api/EmployeeLocation';
